import type { CheckboxProps as MuiCheckboxProps } from "@mui/material/Checkbox";
import MuiCheckbox from "@mui/material/Checkbox";
import MuiFormControlLabel from "@mui/material/FormControlLabel";
import { useId } from "react";
import { Typography } from "../../General";

import styles from "./Checkbox.module.scss";

interface CheckboxItemProps
    extends Pick<MuiCheckboxProps, "checked" | "disabled" | "name" | "onChange" | "value"> {
    alignTop?: boolean;
    inputRef?: React.Ref<HTMLInputElement>;
    label: string | React.ReactNode;
    labelPlacement?: "end" | "start";
}

export function CheckboxItem({
    alignTop = false,
    checked,
    disabled,
    inputRef,
    label,
    labelPlacement = "end",
    name,
    onChange,
    value,
}: CheckboxItemProps) {
    const id = useId();

    return (
        <MuiFormControlLabel
            className={`${styles["label"]} ${alignTop ? styles["label--align-top"] : ""} ${labelPlacement === "start" ? styles["label--is-end"] : ""}`}
            control={
                <MuiCheckbox
                    checked={checked}
                    className={alignTop ? styles["checkbox--align-top"] : ""}
                    disabled={disabled}
                    id={id}
                    inputRef={inputRef}
                    name={name}
                    onChange={onChange}
                    value={value}
                />
            }
            htmlFor={id}
            label={typeof label === "string" ? <Typography>{label}</Typography> : label}
            labelPlacement={labelPlacement}
        />
    );
}
